import React from 'react';
import { Field } from 'redux-form';
import { MenuItem } from '@material-ui/core';
import { FieldWrapper } from './index';
import { FormTextField } from '../../../../components/Form/index';
import { maxLength, required } from '../../../../utils/validators';
import {
  ADDRESS_MAX_STRING_LENGTH,
  REGISTRATION_MAX_STRING_LENGTH
} from '../../../../constants';
import STATES from '../../../../constants/states';

const addressMaxStringLength = maxLength(ADDRESS_MAX_STRING_LENGTH);
const maxStringLength = maxLength(REGISTRATION_MAX_STRING_LENGTH);
const zipCodeValidation = value =>
  value && !/^[0-9]{5}(?:-[0-9]{4})?$/.test(value)
    ? 'ZIP Code have invalid format'
    : undefined;

const AddressComponent = () => (
  <>
    <FieldWrapper>
      <Field
        name="street"
        component={FormTextField}
        label="Street Address"
        fullWidth
        validate={[required, addressMaxStringLength]}
      />
    </FieldWrapper>
    <FieldWrapper sm={6}>
      <Field
        name="city"
        component={FormTextField}
        label="City"
        fullWidth
        validate={[required, maxStringLength]}
      />
    </FieldWrapper>
    <FieldWrapper sm={3}>
      <Field
        name="state"
        component={FormTextField}
        label="State"
        select
        fullWidth
        validate={required}
        SelectProps={{
          MenuProps: {
            style: {
              maxHeight: 400
            }
          }
        }}
      >
        {STATES.map(state => (
          <MenuItem key={state.abbreviation} value={state.abbreviation}>
            {state.name}
          </MenuItem>
        ))}
      </Field>
    </FieldWrapper>
    <FieldWrapper sm={3}>
      <Field
        name="zip"
        component={FormTextField}
        label="ZIP"
        fullWidth
        validate={[required, zipCodeValidation]}
      />
    </FieldWrapper>
  </>
);

export default AddressComponent;
